import React from 'react';
import PageHeader, { Highlight } from '../components/ui/PageHeader';
import Button from '../components/ui/Button';
import Chip from '../components/ui/Chip';
import ProgressBar from '../components/ui/ProgressBar';
import BuildConsole from '../components/features/BuildConsole';
import BuildSettingsPanel from '../components/features/BuildSettings';
import DropZone from '../components/features/DropZone';
import { useBuild } from '../hooks/useBuild';

const ApkBuilderPage: React.FC = () => {
  const { buildStatus, buildProgress, buildPhase, buildLogs, startBuild, cancelBuild, isBuilding, isSuccess } = useBuild();

  return (
    <>
      <PageHeader
        title={<>APK <Highlight>Builder</Highlight></>}
        subtitle="Compile your React Native project to a signed release APK"
      />

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 20 }}>
        <Chip variant="success">✓ SDK Ready</Chip>
        <Chip variant="success">✓ JDK 17</Chip>
        <Chip variant="info">Gradle 8.4</Chip>
        <Chip variant="warn">⚠ Keystore needed</Chip>
        <Chip variant={isBuilding ? 'warn' : 'muted'}>
          {isBuilding ? `● ${buildPhase}` : isSuccess ? '● Done' : '● Idle'}
        </Chip>
      </div>

      <DropZone accept={['.js', '.ts', '.tsx', '.jsx', '.zip']} />

      <BuildSettingsPanel />

      {buildProgress > 0 && (
        <ProgressBar value={buildProgress} label={buildPhase || 'Building...'} />
      )}

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 20 }}>
        <Button variant="primary"    icon="⬢"  onClick={startBuild}  disabled={isBuilding} loading={isBuilding}>
          {isBuilding ? 'Building...' : 'Build APK'}
        </Button>
        <Button variant="purple"    icon="◈"  disabled={isBuilding}>Convert via Capacitor</Button>
        <Button variant="secondary" icon="⊞"  disabled={isBuilding}>Clean Build</Button>
        <Button variant="danger"    icon="✕"  disabled={!isBuilding} onClick={cancelBuild}>Cancel</Button>
      </div>

      <BuildConsole logs={buildLogs} isBuilding={isBuilding} />

      {isSuccess && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          <Button variant="primary"   icon="⬇">Download APK</Button>
          <Button variant="secondary" icon="◎">View Logs</Button>
          <Button variant="secondary" icon="⧉">Share Link</Button>
        </div>
      )}
    </>
  );
};

export default ApkBuilderPage;
